<template>
    <console-content max-width="1560">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">캐시 내역</v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>
        
        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-date-field v-model="filter.createdAt[0]" type="date" clearable label="승인일자" placeholder=" " ></v-date-field>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-date-field v-model="filter.createdAt[1]" type="date" clearable label="승인일자" placeholder=" " ></v-date-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.type" :items="types" item-text="text" item-value="value" label="결제타입" placeholder=" " hide-details/>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null;"/>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true);">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>
        
        <v-row class="mt-6 px-1">
            <v-col cols="auto" class="py-0"></v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-text-field v-model="excelLimit" label="엑셀 다운로드 행 개수" placeholder=" " class="d-inline-block mr-2" />
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table :loading="loading" :items="cashes" :headers="cashesHeaders" :items-per-page="limit" hide-default-footer disable-sort class="mt-3 mx-1 elevation-1">
            <template v-slot:item.createdAt="{item}">
                <span v-if="item.createdAt">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.tno="{item}">
                <!-- <a v-if="item.type == '선물'" @click="modalGift(item.tno)" class="text-decoration-none">{{ item.tno }}</a> -->
                <a v-if="item.type == '선물'" @click="modalGift2(item)" class="text-decoration-none">{{ item.tno }}</a>
                <span v-else>{{ item.tno }}</span>
            </template>
            <template v-slot:item.amount="{ item }">
                <span v-if="item.amount">{{ item.amount.format() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.result="{ item }">
                <span v-if="item.result">{{ item.result.format() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.pno="{ item }">
                <span v-if="item.pno" @click="$refs.pinStatusDialog.open(item)">{{ item.pno }}</span> 
                <span v-else></span>
            </template>
            <template v-slot:item.remain="{ item }">
                <span>{{ item.remain }}</span> 
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)" />

    <v-dialog v-model="show" max-width="560">
        <v-card v-if="selected">
            <v-card-title class="subtitle-1">캐시 선물 내역</v-card-title>
            <v-data-table :headers="senderHeaders" :items="selected" class="elevation-1" hide-default-footer >
                <template v-slot:item.gift.sender.name="{item}">
                    <span>{{item.gift.sender.name}}</span>
                    <span>({{item.gift.sender.username}})</span>
                </template>
                <template v-slot:item.gift.createdAt="{item}">
                    <span>{{$dayjs(item.gift.createdAt).format("YYYY-MM-DD HH:mm:ss")}}</span>
                </template>
            </v-data-table>   
            <v-data-table :headers="receiverHeaders" :items="selected" class="elevation-1" hide-default-footer >
                <template v-slot:item.gift.receiver.name="{item}">
                    <span>{{item.gift.receiver.name}}</span>
                    <span>({{item.gift.receiver.username}})</span>
                </template>
                <template v-slot:item.gift.takedAt="{item}">
                    <span v-if="item.gift.takedAt">{{$dayjs(item.gift.takedAt).format("YYYY-MM-DD HH:mm:ss")}}</span>
                    <span v-else>-</span>
                </template>
            </v-data-table>           
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="grey" @click="show=false">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <pin-status-dialog ref="pinStatusDialog"/>
    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import pinStatusDialog from '@/components/console/caches/pin-status-dialog.vue';
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        pinStatusDialog,
        ConsoleContent,
        VDateField
    },
    data(){
        return {
            mdiMicrosoftExcel,
            show: false,
            loading: true,
            showSearch: true,
            pinStatusDialog: false,

            filter: {
                type: this.$route.query.type,
                createdAt: [this.$route.query.createdAt?.[0] || this.$dayjs().startOf('year').format("YYYY-MM-DD"), this.$route.query.createdAt?.[1] || this.$dayjs().endOf('year').format("YYYY-MM-DD")],
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "member.name" },
                { text: "아이디", value: "member.username" },
                { text: "연락처", value: "member.phone" },
                { text: "주문번호", value: "orderNo" },
                { text: "승인번호", value: "tno" },
            ],

            page: 1,
            pageCount: 0,
            limit: 20,

            excelLimit: 0,

            cashes: [],
            cashesHeaders: [
                { text: "승인일자", align: "center", width: 180, value: "createdAt" },
                { text: "결제타입", align: "center", width: 80, value: "type" },
                { text: "주문번호", align: "center", width: 100, value: "orderNo" },
                { text: "승인번호", align: "center", width: 100, value: "tno" },
                { text: "캐시내역", align: "center", width: 250, value: "remark" },
                { text: "금액", align: "center", width: 100, value: "amount" },
                { text: "잔액", align: "center", width: 100, value: "result" },
                { text: "ID", align: "center", width: 80, value: "member.username" },
                { text: "이름", align: "center", width: 100,  value: "member.name" },
                { text: "핀번호", align: "center", width: 100, value: "pno" },
                { text: "percent", align: "center", width: 50, value: "percent" },
                { text: "remain", align: "center", width: 50, value: "remain" },
            ],

            types: [
                { text: ":: 전체 ::", value: null },
                { text: "리워드", value: "리워드" },
                { text: "선물", value: "선물" },
                { text: "충전", value: "충전" },
                { text: "주문", value: "주문" },
                { text: "부분취소", value: "부분취소" },
                { text: "취소", value: "취소" },
            ],
            
            senderHeaders: [
                { text: '보낸 사람', value: 'gift.sender.name', },
                { text: '금액', value: 'gift.amount' },
                { text: '상태', value: 'gift.status' },
                { text: '보낸 일자', value: 'gift.createdAt' },
            ],
            receiverHeaders: [
                { text: '받는 사람', value: 'gift.receiver.name', width: '50%', align: 'center'},
                { text: '받은 일자', value: 'gift.takedAt' },
            ],

            selected: []
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                })
            }

            this.loading = true;
            this.cashes = [];
            
            var { summary, cashes } = await api.console.cashes.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.loading = false;
            this.cashes = cashes;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.excelLimit = summary.totalCount <= 100000 ? summary.totalCount : 100000;

        },

        modalGift(tno){
            window.open(`https://daehanbooks.co.kr/adm/manage/cash/cash-gift-popup.php?tid=${tno}`,"cashUp","height=600, width=650, menubar=no, scrollbars=yes, resizable=yes, toolbar=no, status=no, top=100, left=100");
        },

        modalGift2(item){
            this.show = true
            this.selected = [item]
        },

        async excel(){
            try{
                if(this.excelLimit == 0) throw new Error("다운로드 행 갯수를 입력해주세요");

                var { cashes } = await api.console.cashes.gets({
                    headers: {
                        limit: this.excelLimit
                    },
                    params: this.filter
                });
    
                var rows = [];
                cashes.forEach(cash => {
                    rows.push({
                        "승인일자": cash.createdAt ? this.$dayjs(cash.createdAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                        "결제타입": cash.type,
                        "주문번호": cash.orderNo,
                        "승인번호": cash.tno,
                        "캐시내역": cash.remark,
                        "금액": parseInt(+cash.amount || 0).format(),
                        "잔액": parseInt(+cash.result || 0).format(),
                        "ID": cash.member?.username || "-",
                        "이름": cash?.member?.name || "삭제회원",
                        // "핀번호": cash.pno ? cash.pno.substr(0, 10) + "**********" : "", // 핀번호 마스킹
                        "핀번호": cash.pno ? cash.pno : "",
                        "percent": cash.percent,
                        "remain": cash.remain,
                    });
                });
    
                var workbook = new XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(rows);
    
                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, "캐시 목록.xlsx");

            }
            catch(error){
                alert(error.message);
            }
        },
    }
}
</script>